<template>
  <article class="buckets-list-article">
    <h3>Vos panier en cours</h3>
    <router-link
      v-for="(bucket, index) in openBuckets"
      :key="index"
      :to="`/bucket/${bucket.id}`"
      class="bucket"
      @click="goToBucket(bucket)"
    >
      <b>Panier du {{ bucket.date }}</b>
      <i>Modifié le {{ bucket.updateDate }}</i>
      <p>{{ bucket.mealsCount }} Repas</p>
      <p>{{ bucket.ingredientsCount }} éléments</p>
    </router-link>

    <button v-if="closedBuckets === null" @click="getClosedBuckets">
      Afficher l'historique
    </button>
    <h3 v-if="closedBuckets !== null">Paniers terminés</h3>
    <div
      v-for="(bucket, index) in closedBuckets"
      :key="`closed-${index}`"
      class="bucket"
    >
      <b>Panier du {{ bucket.date }}</b>
      <i>Modifié le {{ bucket.updateDate }}</i>
      <p>{{ bucket.mealsCount }} Repas</p>
      <p>{{ bucket.ingredientsCount }} éléments</p>
      <b>TOTAL : 1000€</b>
      <!-- <button>duppliquer</button> -->
    </div>
  </article>
</template>

<script>
import _ from 'lodash';

import bucketsService from '../../../services/buckets.service';
import utilsService from '../../../services/utils.service';

export default {
  data() {
    return {
      openBuckets: [],
      closedBuckets: null,
      closeBucketsLimit: 0,
    };
  },
  created() {
    this.getOpenBuckets();
  },
  methods: {
    /**
     * Met correctement en forme une liste de buckets
     */
    setBucketsData(buckets) {
      return buckets.map((bucket) => {
        return {
          ...bucket,
          // Date firestore: toDate() existe
          date: utilsService.toFrenchDate(bucket.createdOn.toDate()),
          updateDate: utilsService.toFrenchDate(bucket.updatedOn.toDate()),
          // Count
          mealsCount: _.get(bucket, 'selectedMealsId', []).length,
          ingredientsCount: _.get(bucket, 'selectedIngredientsId', []).length,
        };
      });
    },
    /**
     * Récupère les paniers ouverts
     */
    async getOpenBuckets() {
      this.openBuckets = await bucketsService.getOpenBuckets();
      this.openBuckets = this.setBucketsData(this.openBuckets);
    },
    /**
     * Récupère les paniers fermés
     */
    async getClosedBuckets() {
      // this.closedBuckets null par défaut pour afficher le btn. On init à []
      this.closedBuckets = [];
      this.closedBuckets = await bucketsService.getClosedBuckets();
      this.closedBuckets = this.setBucketsData(this.closedBuckets);
    },
  },
};
</script>

<style lang="scss" scoped src="./BucketsList.scss"></style>
